import { create_div, onscreen, get_offset, get_el } from 'js/utils';

export default class Timeline {
    
    constructor(options){
        this.options = options;
        this.container = get_el(options.container);
        this.rows = get_el(options.rows, true);
        this.trigger_offset = options.trigger_offset ?? 200;
        this.rows_gap = this.get_sections_row_gap();
        this.init();
    }

    init(){
        this.create_line();
        this.create_dots();
        this.set_line_height();
        this.set_dots_position();
        this.calculate();
        this.init_scroll();
        this.resize_recalculate();
    }

    create_line(){
        this.timeline_con = create_div('timeline_line_con', this.container);
        this.line_con = create_div('line_con', this.timeline_con);
        this.line_active = create_div('line_active', this.line_con);
    }

    set_line_height(){
        
        let clip_top = this.rows[0].offsetHeight/2;

        let clip_bottom = this.rows[this.rows.length-1].offsetHeight/2;
        clip_bottom += this.dots[0].offsetHeight;

        this.line_con.style.clipPath = `inset(${clip_top}px 0 ${clip_bottom}px)`;
        
        this.line_height = this.container.offsetHeight;
    }

    create_dots(){

        const dots = [];

        this.rows.forEach((row, i)=>{

            let dot_class = `dot dot-${i+1}`;
            if( i == 0 ) dot_class += ' first';
            if( i == this.rows.length-1 ) dot_class += ' last';

            const dot = create_div(dot_class, this.timeline_con);

            dot.row = row;
            dots.push(dot);
        });

        this.dots = dots;
        this.dots_index = 0;
        this.dots_current = dots[this.dots_index];
    }

    set_dots_position(){

        let distance = 0;
        let gap = this.rows_gap;

        let dots_offset = this.dots[0].offsetHeight/2;
        
        distance -= dots_offset;

        this.dots.forEach((dot, i)=>{
            
            let dot_pos = dot.row.offsetHeight/2;

            let dot_prev = this.dots[i-1];
            if( dot_prev ) {
                dot_pos += dot_prev.row.offsetHeight/2;
                dot_pos += gap;
            }
            
            distance += dot_pos;
            dot.activate_point = distance;
            dot.style.top = `${distance}px`;
        })
    }

    init_scroll(){
        
        this.scroll = {
            active: false,
            direction: 'down',
            delta: 0,
        };
        
        onscreen(this.line_con, {
            on: this.activate.bind(this),
            off: this.deactivate.bind(this),
        })

        window.addEventListener('scroll', this.on_scroll.bind(this), { passive: true });
    }

    activate(){
        // console.log('activate')
        this.scroll.active = true;
        this.dots_index = 0;
        this.dots_current = this.dots[this.dots_index];
    }

    deactivate(){
        // console.log('deactivate')
        // this.scroll.active = false;
    }
    
    on_scroll(){
        if( !this.scroll.active ) return;
        this.scroll.direction = (window.scrollY - this.scroll.delta) < 0 ? 'up' : 'down';
        this.update_line_height();
        this.check_dot_active();
        this.scroll.delta = window.scrollY;
    }
    
    update_line_height(){
        this.height = window.scrollY + this.trigger - this.start_point
        if( this.height < 0 ) this.height = 0;
        if( this.height > this.line_height ) this.height = this.line_height;
        this.line_active.style.height = this.height+'px';
    }

    resize_recalculate(){
        let resize_throttle = false;
        window.addEventListener('resize', ()=>{
            if( resize_throttle ) return;
            resize_throttle = true;
            this.calculate();
            setTimeout(()=>{ resize_throttle = false; }, 100);
        });
    }
    
    calculate(){
        this.start_point = get_offset(this.line_active).top;
        this.trigger = window.innerHeight - this.trigger_offset;
        this.update_line_height();
        this.init_line_guide();
    }
    
    check_dot_active(){
        
        if( this.scroll.direction == 'down' ) {
            if( this.height >= this.dots_current.activate_point ) {
                this.dot_set_active_down();
            }
        }
        else {
            // up
            if( this.height < this.dots_current.activate_point ) {
                this.dot_set_active_up();
            }
        }
    }
    
    dot_set_active_down(){
        this.dots_current.classList.add('active');
        this.dots_current.row.classList.add('active');
        this.dots_index++;
        if( this.dots[this.dots_index] ) {
            this.dots_current = this.dots[this.dots_index];
        }
    }
    
    dot_set_active_up(){
        this.dots_current.classList.remove('active');
        this.dots_current.row.classList.remove('active');
        this.dots_index--;
        if( this.dots[this.dots_index] ) {
            this.dots_current = this.dots[this.dots_index];
        }
    }

    init_line_guide(){
        let enable = this.options.line_guide ?? false;
        if( !enable ) return;
        if( !this.line_guide ) {
            this.line_guide = create_div('line_guide', document.body);
        }
        let guide = this.line_guide;
        guide.style.position = 'fixed';
        guide.style.top = this.trigger + 'px'; 
        guide.style.right = 0;
        guide.style.width = '100%';
        guide.style.height = '1px';
        guide.style.background = 'green';
        guide.style.zIndex = 100;
    }
    
    get_sections_row_gap(){
        let con = this.container.querySelector('.e-con-inner');

        if( !con ) {
            // support for older version of elementor
            con = this.container;
        }

        if( !con ) return 0;

        const styles = getComputedStyle(con)
    
        let row_gap = styles.rowGap;
        row_gap = row_gap.replace('px', '');
        row_gap = parseInt(row_gap);
    
        return row_gap;
    }
}